import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import StaffAugmentation from './pages/services/StaffAugmentation';
import PermanentRecruitment from './pages/services/PermanentRecruitment';
import ContractToHire from './pages/services/ContractToHire';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/staff-augmentation" element={<StaffAugmentation />} />
            <Route path="/services/permanent-recruitment" element={<PermanentRecruitment />} />
            <Route path="/services/contract-to-hire" element={<ContractToHire />} />
            <Route path="/contact-us" element={<Contact />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
